import { NgModule } from '@angular/core';
import { EditorLoadingComponent } from './editor-loading/editor-loading.component';
import { EditorUnavailableComponent } from './editor-unavailable/editor-unavailable.component';
import { EnrichEditorService } from './services/enrich-editor.service';
import { EnrichViewerService } from './services/enrich-viewer.service';
import { GroupBySearchService } from './services/gb-search.service';

@NgModule({
  declarations: [
    EditorLoadingComponent,
    EditorUnavailableComponent,
  ],
  entryComponents: [
    EditorLoadingComponent,
    EditorUnavailableComponent,
  ],
  providers: [
    EnrichEditorService,
    EnrichViewerService,
    GroupBySearchService,
  ],
})
export class EnrichEditorModule {}



// WEBPACK FOOTER //
// ./src/app/editor/enrich-editor.module.ts